if (!customElements.get('section-collection-list')) {
    class TG_SectionCollectionList extends HTMLElement {
      constructor() {
        super();
      }
      
      connectedCallback() {
        var _this = this;
  
        this.delegateElement = new themegoal.libs.Delegate(this);
        this.carousels = [];
  
        themegoal.helpers.Dom.nodeListToArray(this.querySelectorAll('[data-carousel-config]')).forEach(function (item) {
            _this.carousels.push(new themegoal.components.Carousel(item));
        });
  
      }
  
      disconnectedCallback(){
        if(this.delegateElement)this.delegateElement.destroy();
        if(this.carousels){
          this.carousels.forEach(function (carousel) {
            carousel.destroy();
          });
        }
      }
    }
          
    customElements.define('section-collection-list', TG_SectionCollectionList);
  }